/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Topics_From_TranscriptInputs */



/**
* | output |
* | --- |
* | "from the transcript" |
*
* @param {Meeting_Topics_From_TranscriptInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_topics_from_transcript = /** @type {((inputs?: Meeting_Topics_From_TranscriptInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Topics_From_TranscriptInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("uit het transcript")
	if (locale === "fr") return /** @type {LocalizedString} */ ("à partir de la transcription")
	return /** @type {LocalizedString} */ ("from the transcript")
});